
import base from "./base.service";

const instance = base.service(); 

export const getAll = () => {
  return instance.get("/popunjeniOdgovor/all");
};

export const deletePopunjeniOdgovor = (id) => {
  return instance.delete(`/popunjeniOdgovor/${id}`);
};

export const addPopunjeniOdgovor = (noviPopunjeniOdgovor) => {
  return instance.post(`/popunjeniOdgovor`, noviPopunjeniOdgovor);
};


export const getById = (id) => {
  return instance.get(`/popunjeniOdgovor/${id}`);
};


export const getAllByPitanjeId = (id) => {
  return instance.get(`/popunjeniOdgovor/pitanje/${id}`);
};

export const getAllBySerialNum = (serialNum) => {
  return instance.get(`/popunjeniOdgovor/instance/${serialNum}`);
};

export const getAllByPitanjeAndSerialNum = (id, serialNum) => {
  return instance.get(`/popunjeniOdgovor/instance/${id}/${serialNum}`);
};

export const getCountByPitanjeIdAndTekst = (id, tekst) => {
  return instance.get(`/popunjeniOdgovor/pitanje/${id}/ukupnoSaTimTekstom`, {
    params: { tekst },
  });
};

export const addBatchPopunjeniOdgovor = (listaPopunjenihOdgovora) => {
  return instance.post("/popunjeniOdgovor/batch", listaPopunjenihOdgovora);
};

export default {
  getAll,
  deletePopunjeniOdgovor,
  addPopunjeniOdgovor,
  getAllByPitanjeId,
  getCountByPitanjeIdAndTekst,
  getAllBySerialNum,
  getAllByPitanjeAndSerialNum,
  addBatchPopunjeniOdgovor,
};
